/**
 * Created by osirvent on 25/04/2017.
 */
angular
    .module('annexaApp')
    .component('annexaRegisterDocument', {
        templateUrl: './components/reg/annexa-register-document/annexa-register-document.html',
        controller: ['Language', '$scope', function (Language, $scope) {
            var vm = this;

            vm.languageColumn = Language.getActiveColumn();

            this.$onInit = function () {
                var getButtonModel = function (button) {
                    var model = undefined;

                    if(button) {
                        model = {};
                        model[button.id] = undefined;

                        _.forEach(button.params, function (val, index) {
                            if (val.frontendType == 'INPUT' || val.frontendType == 'TEXTAREA' || val.frontendType == 'JSON') {
                                button.params[index].optionsUrl = undefined;
                                if(!model[button.id]) {
                                    model[button.id] = {};
                                }

                                model[button.id][val.id] = undefined;
                            }
                        })
                    }

                    return model;
                }

                $scope.$on('annexaCustomFieldComponentModelChanged', function (event, args) {
                    if(args.plugin){
                        if(!vm.model[args.plugin]){
                            vm.model[args.plugin] = {};
                        }
                        vm.model[args.plugin][args.key] = args.model;
                    }

                });

                vm.model = getButtonModel(vm.plugin);

                if (vm.plugin.id && vm.plugin.id === 'document_sicres_button') {
                    var document_params_sicres = ($scope.$root && $scope.$root.app && $scope.$root.app.configuration && $scope.$root.app.configuration.document_params_sicres)?$scope.$root.app.configuration.document_params_sicres:undefined;
                    if (document_params_sicres) {
                        _.forEach(vm.plugin.params, function (val, index) {
                            vm.model[vm.plugin.id][val.id] = document_params_sicres[val.id];
                        });
                    }
                }
            }
        }],
        bindings: {
            plugin: '=',
            submitFunction: '=',
            model: '='
        }
    })